import { useEffect } from 'react'

export const META_PIXEL_ID = '1503968967726103'

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

export function trackPixel(event: string, params?: Record<string, unknown>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', event, params)
  }
}

export function useMetaPixel() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView')
      return
    }

    const fbq: Fbq = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue?.push(args)
      }
    } as Fbq

    window.fbq = fbq
    window._fbq = window._fbq || fbq
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    const noscript = document.createElement('noscript')
    const pixelImg = document.createElement('img')
    pixelImg.height = 1
    pixelImg.width = 1
    pixelImg.style.display = 'none'
    pixelImg.alt = ''
    pixelImg.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
    noscript.appendChild(pixelImg)
    document.body.appendChild(noscript)

    fbq('init', META_PIXEL_ID)
    fbq('track', 'PageView')
  }, [])
}
